import { render, staticRenderFns } from "./Shop.vue?vue&type=template&id=76c01af1"
import script from "./Shop.vue?vue&type=script&lang=ts"
export * from "./Shop.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports